import * as React from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

interface NotificationItemSummaryProps {
  className?: string;
  title?: React.ReactNode;
  text?: React.ReactNode;
}

export const NotificationItemSummary: React.FC<NotificationItemSummaryProps> = ({
  className,
  title,
  text,
}) => {
  return (
    <ItemWrapper className={className}>
      <ItemContent>
        <Mark />
        <ItemText>
          {title && <StyledTitle>{title}</StyledTitle>}
          {text && <StyledText>{text}</StyledText>}
        </ItemText>
      </ItemContent>
    </ItemWrapper>
  );
};

export default NotificationItemSummary;

const ItemContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ItemText = styled.div`
  justify-content: 'center';
  align-items: 'center';
  flex-direction: 'column';
  flex-grow: '1';
`;

const ItemWrapper = styled(MotionOpacity)`
  margin-bottom: 16px;
  opacity: 1;

  @media ${({ theme }) => theme.device.laptop} {
    position: relative;
    margin-bottom: 24px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const Mark = styled.div`
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.hint};
  margin-left: 0px;
  margin-right: 16px;
  margin-top: 4px;

  @media ${({ theme }) => theme.device.laptop} {
    width: 16px;
    height: 16px;
    margin-left: 12px;
    margin-right: 36px;
  }
`;

const StyledTitle = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.h4};
  font-weight: 700;
  position: relative;
  margin-bottom: 8px;

  @media ${({ theme }) => theme.device.laptop} {
    font-size: ${({ theme }) => theme.typography.h3};

    &:after {
      content: none;
    }
  }
`;

const StyledText = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.h4};

  @media ${({ theme }) => theme.device.laptop} {
    font-size: ${({ theme }) => theme.typography.h3};
  }
`;
